import { render } from "./FCInput.vue?vue&type=template&id=0ad5a5ef&scoped=true"
import script from "./FCInput.vue?vue&type=script&lang=js"
export * from "./FCInput.vue?vue&type=script&lang=js"

import "./FCInput.vue?vue&type=style&index=0&id=0ad5a5ef&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad5a5ef"]])

export default __exports__